import logo from "shared/assets/images/logo.svg";

const View = ({ provider, onSubmit, onLinkClick, onZitadelLogin }) => {
  const LoginComponent = provider.LoginComponent;
  return (
    <div className="auth">
      <img alt="logo" src={logo} />
      <LoginComponent
        onSubmit={onSubmit}
        onLinkClick={onLinkClick}
        onZitadelLogin={onZitadelLogin}
      />
    </div>
  );
};

export default View;
